import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ type: "spring", stiffness: 120, damping: 20, delay }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => (
  <p className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400 mb-4">
    {children}
  </p>
);

export const SectionHeading = ({ children, className = "" }) => (
  <h2
    className={`text-3xl sm:text-4xl lg:text-5xl font-heading font-extrabold tracking-tight uppercase leading-[0.95] ${className}`}
  >
    {children}
  </h2>
);
